<template>
    <div class="container" v-if="organization">
        <v-title :lineage="[{'Organizations':'organizations'}]">
            <span v-fs-block>{{ organization.name | truncate({limit: 26, dots: true}) }}</span>
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-website'].isAllowed"
                    :to="{name: 'add-website', params: {organizationId: id}}"
                    class="btn btn-link">Add Website<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item grid-item-primary">
                <div class="grid">
                    <div class="grid-item grid-item-full">
                        <website-list
                            :organization="organization"
                            :websites-custom-fields="websitesCustomFields"/>
                    </div>
                </div>
            </div>
            <div class="grid-item grid-item-secondary">
                <div class="tile">
                    <div class="tile-title">
                        <h2>Organization Info</h2>
                        <router-link class="no-flex" :to="{name: 'update-organization', params: {id: organization.id}}">Edit</router-link>
                    </div>
                    <div class="tile-content">
                        <p class="text-muted">Created on {{ organization.createdTime | dateTime }}</p>
                        <p class="text-muted">Updated on {{ organization.updatedTime | dateTime}}</p>
                    </div>
                    <div class="tile-content tile-content-secondary" v-if="hasLogo">
                        <img class="image image-logo image-center no-margin-bottom" :src="previewUrl"/>
                    </div>
                    <div class="tile-content">
                        <table class="table table-definition table-collapsed table-v-alignment-top">
                            <colgroup>
                                <col style="width:130px;">
                                <col>
                            </colgroup>
                            <tr>
                                <td>Name</td>
                                <td v-fs-block>{{ organization.name }}</td>
                            </tr>
                            <tr>
                                <td>ID</td>
                                <td v-fs-block>{{ organization.id }}</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td v-fs-block>{{ getOrganizationInfo(organization.address) }}<br>{{ getOrganizationInfo(organization.address2) }}</td>
                            </tr>
                            <tr>
                                <td>City</td>
                                <td v-fs-block>{{ getOrganizationInfo(organization.city) }}</td>
                            </tr>
                            <tr>
                                <td>Country</td>
                                <td v-fs-block>{{ organization.country }}</td>
                            </tr>
                            <tr>
                                <td>Postal Code</td>
                                <td v-fs-block>{{ getOrganizationInfo(organization.postalCode) }}</td>
                            </tr>
                            <tr>
                                <td>Phone Number</td>
                                <td v-fs-block>
                                    <p v-for="item in getPhonesEmails(organization.phoneNumbers)">{{ item }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>Email Address</td>
                                <td v-fs-block>
                                    <p v-for="item in getPhonesEmails(organization.emails)">{{ item }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>Tax Descriptor</td>
                                <td v-fs-block>{{ getOrganizationInfo(organization.taxDescriptor) }}</td>
                            </tr>
                            <tr>
                                <td>Invoice Time Zone</td>
                                <td v-fs-block>{{ getOrganizationInfo(organization.invoiceTimeZone) }}</td>
                            </tr>
                            <tr>
                                <td>Primary</td>
                                <td v-fs-block>{{ isPrimary }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        vIcon,
    } from '@/components/form';
    import vTitle from '@/components/v-title';
    import _ from '@/common/helpers';
    import OrganizationModel from '@/common/models/organization-model';
    import FormLoaderMixin from '@/mixins/form-loader-mixin';
    import WebsiteList from './components/website-list';

    export default {
        name: 'organization-details',
        mixins: [FormLoaderMixin],
        components: {
            vTitle,
            vIcon,
            WebsiteList,
        },
        props: {
            id: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                organization: null,
                previewUrl: null,
                websitesCustomFields: [],
            };
        },
        computed: {
            hasLogo() {
                return !_.isBlank(this.previewUrl);
            },
            isPrimary() {
                return this.organization.isPrimary ? 'Yes' : 'No';
            },
        },
        methods: {
            getPhonesEmails(value) {
                return !value.length ? this.$emptyInnerHTML() : value.map(item => item.value);
            },
            getOrganizationInfo(value) {
                return _.isBlank(value) ? this.$emptyInnerHTML() : value;
            },
            async getAttachment() {
                const {items, total} = await this.$api(({files}) => files.getAllAttachments({
                    filter: `relatedId:${this.organization.id};relatedType:organization`,
                    sort: '-createdTime',
                }));
                if (total > 0) {
                    const [attachment] = items;
                    const {fields} = await this.$api(({files}) => files.get({id: attachment.fields.fileId}));
                    /* eslint-disable no-underscore-dangle */
                    this.previewUrl = fields._links.find(link => link.rel === 'signedLink').href;
                }
            },
            async fetchData() {
                const [
                    {fields},
                    {items: websitesCustomFields},
                ] = await Promise.all([
                    this.$api(({companies}) => companies.get({id: this.id})),
                    this.$api(({customFields}) => customFields.getAll({resource: 'websites'})),
                ]);
                this.organization = new OrganizationModel(fields);
                this.websitesCustomFields = websitesCustomFields;
                await this.getAttachment();
            },
        },
    };
</script>
